import styled from "styled-components";
import { getSiteAsset } from "../../utils";
const StyledLoanPrograms = styled.section`
  & {
    background: #000822;
    padding-block: 1.5rem;
    transition: height 0.4s ease-in;
  }
  & .back-button {
    position: absolute;
    top: -2rem;
    left: 0;
    height: 30px;
    width: 40px;
    background-image: url("https://prod-cdn.swmc.com/mlo-landing-pages/images/backarrow.webp");
    background-size: contain !important;
    background-position: center;
    background-repeat: no-repeat;
    z-index: 10;
    cursor: pointer;
  }
  & .back-button:hover {
    transform: scale(1.1);
  }
  & .product-col {
    transition: transform 0.5s ease-in, width 0.5s ease-in, opacity 0.5s ease-in;
  }
  & .product-col a {
    text-decoration: none;
  }

  & .product-col.hide-product {
    width: 0px;
    transform: scale(0);
    opacity: 0;
  }


  & .loan-product-box {
    margin-block: 1rem;
    // filter: drop-shadow(0px 3.34546px 15.8909px rgba(0, 0, 0, 0.25));
    background: #d9d9d91f;
    border-radius: 5.01818px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    position: relative;
    // box-shadow: 1px 1px 8px rgba(128, 128, 128, 0.43);
    cursor: pointer;
    max-height: 400px;
    min-height: 390px;
    border-bottom: 5px solid rgba(255, 255, 255, 0.10);
  }
  & .less-filter {
    filter: drop-shadow(0px 3.34546px 15.8909px rgba(0, 0, 0, 0.15));
  }

  & .loan-product-box:hover {
    transform: scale(1.01);
    background-color: #FF5601;
  }

  & .hidden {
    transition: 0.3s opacity ease-in;
    opacity: 0;
  }
  & .show {
    transition: 0.3s opacity ease-in;
    opacity: 1;
  }
  & .loan-product-image {
    // filter: drop-shadow(0px 3.34546px 15.8909px rgba(0, 0, 0, 0.25));
    // -webkit-filter: grayscale(100%); /* For Safari 6.0 to 9.0 */
    // filter: grayscale(1);
    aspect-ratio: 4 / 3;
    // transition: filter 0.4 ease-in;
    width: 100%;
    height: 100%;
    padding: 1rem;
    border-radius: 25px;
  }
  & .big .loan-product-image {
    aspect-ratio: 4 / 3;
  }
  & .loan-product-filter {
    position: absolute;
    width: 100%;
    height: 100%;
    // background-color: rgba(0, 0, 0, 0.3);
    z-index: 1;
  }
  & .loan-product-box:hover .loan-product-filter {
    // background-color: #FF5601;
  }
  & .loan-product-box:hover .loan-product-image {
    // filter: grayscale(0);
    // background-color: #FF5601;
  }
  & .loan-product-name {
    position: relative;
    font-weight: 600;
    font-size: 24.2546px;
    line-height: 27px;
    text-align: center;
    text-transform: uppercase;
    color: #ffffff;
    z-index: 2;
    max-width: 280px;
    // text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black;
  }
  & .loan-product-header {
    font-weight: 600;
    font-size: 29px;
    line-height: 44px;
    color: #931668;
  }
  & .loan-product-title {
    display: block;
    text-align: center;
    font-weight: 600;
    font-size: 2.5rem;
    line-height: 44px;
    color: #fff;
    margin-block: 2rem;
  }
  & .hide-main-loanprograms-row{
    display: none;
  }
  & .hide-others{
    display: none;
  }
  @media only screen and (min-width: 1200px) and (max-width: 1399.9px) {
    & .loan-product-box {
      max-height: 350px;
      min-height: 340px;
    }
  }
  @media only screen and (min-width: 992px) and (max-width: 1199.9px) {
    & .loan-product-box {
      max-height: 300px;
      min-height: 290px;
    }
  }
  @media only screen and (max-width: 767px) {
    & .loan-product-title{
      margin-block: 0rem;
    }
    & .loan-product-box{
      max-height: auto;
      min-height: auto;
    }
  }
  @media only screen and (min-width: 767px) and (max-width: 991.9px) {
    & .loan-product-box{
      max-height: 320px;
      min-height: 320px;
    }
  }
  @media only screen and (min-width: 460px) and (max-width: 499.9px) {
    & .loan-product-box{
      max-height: 420px;
      min-height: 420px;
    }
  }
  @media only screen and (min-width: 500px) and (max-width: 539.9px) {
    & .loan-product-box{
      max-height: 430px;
      min-height: 430px;
    }
  }
  @media only screen and (min-width: 540px) and (max-width: 550.9px) {
    & .loan-product-box{
      max-height: 450px;
      min-height: 450px;
    }
  }
  @media only screen and (min-width: 551px) and (max-width: 575.9px) {
    & .loan-product-box{
      max-height: 460px;
      min-height: 460px;
    }
  }
  @media only screen and (min-width: 576px) and (max-width: 766.9px) {
    & .loan-product-box{
      max-height: 460px;
      min-height: 460px;
    }
  }
  @media only screen and (min-width: 992px) {
    & .big .loan-product-image {
      aspect-ratio: 6 / 3;
    }
  }
`;

export default StyledLoanPrograms;
